const ApiConfig = {
  apiBaseUrl: "https://backend.hindustanwardrobe.in",
  // apiBaseUrl: "http://localhost:4000",

  // Admin Auth
  guestToken: "guestToken",
  adminlogin: "/admin/adminLogin",
  adminRegister: "/admin/adminRegister",
  editAdmin: "/admin/editAdmin",
  deleteAdmin: "/admin/deleteAdmin",
  requestResetAdminPassword: "/admin/requestResetAdminPassword",
  resetPassword: "/admin/resetPassword",

  getAdminById: "/admin/getAdminById",
  getAdminUsers: "/admin/getAdminUsers",

  // Dashboard
  dashboardAPI: "/admin/dashboardAPI",

  //products
  getAllProducts: "/user/getAllProducts",
  getTopProducts: "/admin/getTopProducts",
  setTopProducts: "/admin/setTopProducts",

  editProduct: "/admin/editProduct",

  // Main Category
  addMainCat: "/admin/addMainCat",
  editMainCategory: "/admin/editMainCategory",
  getMainCat: "/admin/getMainCat",

  // Category
  addCategory: "/admin/addCategory",
  editCategory: "/admin/editCategory",
  allCategory: "/admin/allCategory",

  // Subcategory
  addSubCategory: "/admin/addSubCategory",
  editSubCategory: "/admin/editSubCategory",
  allSubcategory: "/admin/allSubcategory",

  // Banner
  addBanner: "/admin/addBanner",
  getBanner: "/admin/getBanner",
  setVisibiltyBanner: "/admin/setVisibiltyBanner",
  deleteBanner: "/admin/deleteBanner",

  // Seasonal Collection
  createCollection: "/admin/createCollection",
  editCollection: "/admin/editCollection",
  setActiveCollection: "/admin/setActiveCollection",
  deleteCollection: "/admin/deleteCollection",
  getCollections: "/admin/getCollections",
  addProductsToCollection: "/admin/addProductsToCollection",
  removeProductsFromCollection: "/admin/removeProductsFromCollection",
  getProductListByCollection: "/admin/getProductListByCollection",

  // Sponsor Products
  addSponserProduct: "/admin/addSponserProduct",
  removeSponserProduct: "/admin/removeSponserProduct",
  getSponsorProducts: "/admin/getSponsorProducts",

  getTopProducts: "admin/getTopProducts",
  // Products
  getAllProduct: "/admin/getAllProduct",

  // Users
  getAllUser: "/admin/getAllUser",

  // Orders
  getAllBookingRequest: "/admin/getAllBookingRequest",
  getBookingRequestById: "/admin/getOrderById",

  // Notifications
  sendNotification: "/admin/send-notification",

  // App
  getAppVersion: "/admin/getAppVersion",

  // WhatsApp
  appPromotion: "/admin/appPromotion",
  sendMessagetoInactiveUsers: "/admin/sendMessagetoInactiveUsers",
  filterData: "/admin/filterData",

  // Support
  getSupportTicket: "/admin/getSupportTicket",
  getSupportTicketById: "/admin/getSupportTicketById",
  closeSupportTicket: "/admin/closeSupportTicket",

  // Marketing Analytics
  getMarketingAttribution: "/market/marketing-attribution/all",
  getMarketingAttributionById: "/market/marketing-attribution",

  // Invoice
  getInvoiceById: "/admin/getInvoiceById",
};

export default ApiConfig;
